import emojis_fr from "./emojis_fr";
import emojis_en from "./emojis_en";

const locale =
  window.navigator.language?.toLowerCase()?.substring(0, 2) || "en";
const emojis = locale === "en" ? emojis_en : emojis_fr;
export default emojis;
